module.exports = __webpack_public_path__ + "img/folder-download.7cbcb094.svg";